import { render, staticRenderFns } from "./Func55.vue?vue&type=template&id=88be5b7e"
import script from "./Func55.vue?vue&type=script&lang=js"
export * from "./Func55.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports